(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autify-blog-section"] && !window.DesignMode) return;
  try {
    
    // Store glide instance globally for resize handling
    let glideInstance = null;
  
    // Initialize or destroy glide based on screen size
    function handleGlideState() {
      const glideElement = document.querySelector('.glide--mobile');
      
      if (window.innerWidth <= 800) {
        // Mobile view - initialize carousel if not already done
        if (typeof Glide !== 'undefined' && glideElement && !glideElement.hasAttribute('data-glide-initialized')) {
          try {
            glideInstance = new Glide('.glide--mobile', {
              type: 'carousel',
              perView: 1,
              gap: 16,
              autoplay: 4000,
              animationDuration: 600,
              rewind: true
            });
            
            glideInstance.mount();
            glideElement.setAttribute('data-glide-initialized', 'true');
            console.log('Glide carousel initialized');
          } catch (error) {
            console.error('Error initializing Glide:', error);
          }
        }
      } else {
        // Desktop view - destroy carousel if it exists
        if (glideInstance && glideElement && glideElement.hasAttribute('data-glide-initialized')) {
          try {
            glideInstance.destroy();
            glideElement.removeAttribute('data-glide-initialized');
            glideInstance = null;
            console.log('Glide carousel destroyed');
          } catch (error) {
            console.error('Error destroying Glide:', error);
          }
        }
      }
    }
  
    // Try multiple initialization methods
    document.addEventListener('DOMContentLoaded', handleGlideState);
    
    // Fallback for cases where DOMContentLoaded already fired
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleGlideState);
    } else {
      handleGlideState();
    }
  
    // Additional fallback with timeout
    setTimeout(handleGlideState, 500);
    
    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleGlideState, 150);
    });
  
    // If Glide is loaded asynchronously, try again when it's available
    if (typeof Glide === 'undefined') {
      const checkGlide = setInterval(function() {
        if (typeof Glide !== 'undefined') {
          clearInterval(checkGlide);
          handleGlideState();
        }
      }, 100);
      
      // Stop checking after 5 seconds
      setTimeout(function() {
        clearInterval(checkGlide);
      }, 5000);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autify-collection-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const collectionInfo = document.querySelector(".collection-info");
    const collectionDesc = collectionInfo.querySelector(".collection-info--content-desc");
    const toggleBtn = collectionInfo.querySelector(".collection-info--show-more-toggle");
    const descText = collectionDesc.textContent || collectionDesc.innerText || '';
    
    if (descText.trim().length > 200) {
      toggleBtn.style.display = '';
    } else {
      toggleBtn.style.display = 'none';
    }
    
    toggleBtn.addEventListener('click', () => {
      collectionDesc.classList.toggle('active');
      if (collectionDesc.classList.contains('active')) {
        toggleBtn.innerText = 'show less';
      } else {
        toggleBtn.innerText = '...show more';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autify-mega-menu-component"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('.nav-parents');

  // Toggle main mobile menu
  toggleBtn?.addEventListener('click', function () {
    menu?.classList.toggle('menu-open');
    toggleBtn.classList.toggle('active');
  });

  // Toggle nav-parent on mobile
  menu.querySelectorAll('.nav-parent.has-children > a').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      if (window.innerWidth <= 1100) {
        e.preventDefault();

        const clickedParent = this.parentElement;
        const isActive = clickedParent?.classList.contains('active');

        // Collapse all
        menu.querySelectorAll('.nav-parent.has-children.active').forEach((activeParent) => {
          activeParent.classList.remove('active');
        });

        // Expand clicked if not already active
        if (!isActive) {
          clickedParent?.classList.add('active');
        }
      }
    });
  });

  // Accordion logic for child columns with titles
  menu.querySelectorAll('.child-column:not(.no-title-links) > *:first-child')
    .forEach((heading) => {
    heading.style.cursor = 'pointer';

    heading.addEventListener('click', function () {
      const column = this.closest('.child-column');
      const content = column.querySelector('.child-content');
      const mobIcon = column.querySelector('.mob-icon');

      const allColumns = column.parentElement.querySelectorAll('.child-column:not(.no-title-links)');

      mobIcon.classList.toggle('active');

      allColumns.forEach((col) => {
        const colContent = col.querySelector('.child-content');
        if (col !== column) {
          col.classList.remove('open');
          colContent?.classList.remove('child-open');
        }
      });

      // Toggle current column
      column.classList.toggle('open');
      content.classList.toggle('child-open');
    });
  });

  // Function to trigger the header geolocation button
  window.triggerHeaderGeolocationButton = function() {
    // Wait a bit to ensure DOM is fully loaded
    setTimeout(() => {
      // Try multiple selectors to find the header geolocation button
      const selectors = [
        'header .shopify-app-block.orbe-custom-button-block button.md-orbe-custom-selector',
        'header button.md-orbe-custom-selector',
        '.shopify-app-block.orbe-custom-button-block button',
        '[data-orbe-geolocation-button]',
        '.geolocation-button',
        'button[onclick*="mdAppCustomButtonClick"]',
        'button[onclick*="geolocation"]'
      ];
      
      let headerButton = null;
      
      // Try each selector
      for (const selector of selectors) {
        headerButton = document.querySelector(selector);
        if (headerButton) {
          console.log('Found header geolocation button with selector:', selector);
          break;
        }
      }
      
      if (headerButton) {
        // Try multiple click methods for better compatibility
        try {
          // Method 1: Direct click
          headerButton.click();
          console.log('Triggered header geolocation button (method 1)');
        } catch (e) {
          try {
            // Method 2: Dispatch click event
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            headerButton.dispatchEvent(clickEvent);
            console.log('Triggered header geolocation button (method 2)');
          } catch (e2) {
            // Method 3: Trigger onclick directly
            if (headerButton.onclick) {
              headerButton.onclick();
              console.log('Triggered header geolocation button (method 3)');
            }
          }
        }
      } else {
        console.log('Header geolocation button not found. Trying fallback...');
        
        // Fallback: try to find any button with geolocation-related classes or onclick
        const allButtons = document.querySelectorAll('button');
        for (const button of allButtons) {
          if (button.className.includes('orbe') || 
              button.className.includes('geolocation') || 
              button.className.includes('md-orbe') ||
              (button.onclick && button.onclick.toString().includes('mdAppCustomButtonClick'))) {
            button.click();
            console.log('Triggered fallback geolocation button');
            return;
          }
        }
        
        console.log('No geolocation button found in header');
      }
    }, 100); // Small delay to ensure DOM is ready
  };

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const collectionInfo = document.querySelector(".collection-hero__inner");
    const collectionDesc = collectionInfo.querySelector(".collection-hero__description");
    const toggleBtn = collectionInfo.querySelector(".collection-info--show-more-toggle");
    const descText = collectionDesc.textContent || collectionDesc.innerText || '';

    console.log("foobar")
    console.log(descText.trim().length)
    
    if (descText.trim().length > 200) {
      toggleBtn.style.display = '';
    } else {
      toggleBtn.style.display = 'none';
    }
    
    toggleBtn.addEventListener('click', () => {
      collectionDesc.classList.toggle('active');
      if (collectionDesc.classList.contains('active')) {
        toggleBtn.innerText = 'show less';
      } else {
        toggleBtn.innerText = '...show more';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
